<div class="collection-browse-card">
    <app-collection-card
        [resource]="resource"
        [gtmPrefix]="gtmPrefix"
        [gtmDataCardNumber]="gtmDataCardNumber"
    ></app-collection-card>
    <app-card-title
        [routerLink]="resource.getRouterLink()"
        [height]="50"
        [rows]="2"
        ><span [innerHtml]="resource.title"></span
    ></app-card-title>
</div>
